import { lazyLoad } from 'utils/loadable';

export const ProfileTabLoadable = lazyLoad(
  () => import('./ProfileTab'),
  module => module.ProfileTab,
);
